import {login} from "@/api/login";
import {message} from "ant-design-vue";

export default {
    namespaced: true,
    state: () => ({
        username: '',
        isAuthenticated: false,
    }),
    mutations: {
        setUsername(state, username) {
            state.username = username;
        },
        setAuthenticated(state, status) {
            state.isAuthenticated = status;
        }
    },
    actions: {
        loginSystem({ commit }, data) {
            login(data).then((res) => {
                console.log('测试',res)
                commit('setUsername', '123')
                if (res.code === 0){
                    message.error(res.msg)
                }else if (res.code === 1){
                    commit('setAuthenticated', true);
                }
            })
        },
        logout({ commit }) {
            commit('setUsername', '');
            commit('setAuthenticated', false);
        }
    },
    getters: {
        username: (state) => state.username,
        isAuthenticated: (state) => state.isAuthenticated
    }
};